import React, { useState, useEffect, useRef } from 'react'
import { Button, FormControl, Form, Col, Row } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { FetchUpdateB2COrderTransactionsDesignerRemark } from '../../fetcher'
//import EnumValueTranslations from '../presentational-components/EnumValueTranslations'
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import { enumvaluetranslations } from '../../utils/enumvaluetranslations'
import { parseDoubleToFloat } from '../../utils/formatting/formattingForDoubles'


const DetailedOrder = ({ customerOrder, handleCloseOrder, openAlert }) => {

    console.log("DetailedOrder", customerOrder)
    const FetchUpdateB2COrder = () => { }

    const [allOrderStates, setAllOrderState] = useState({OrderStates: []})
    //const [orderState, setOrderState] = useState(EnumValueTranslations(customerOrder.article.OrderState))
    const [orderState, setOrderState] = useState(customerOrder.OrderState)
    const [orderProcessingState, setOrderProcessingState] = useState(customerOrder.OrderProcessingState) 


    const [designer, setDesigner] = useState(customerOrder.Designer) //useState(customerOrder.article.DesignerName)
    const [customer, setCustomer] = useState(customerOrder.Customer)
    const [remarkAnDesigner, setRemarkAnDesigner] = useState(customerOrder.Remark) //useState(customerOrder.article.Remark)
    const [remarkAnFAEX, setRemarkAnFAEX] = useState(customerOrder.RemarkForFAEX) //useState(customerOrder.article.Remark)
    const [size, setSize] = useState(customerOrder.Size)
    const [amount, setAmount] = useState(customerOrder.Amount)
    const [articleType, setArticleType] = useState(customerOrder.Name)
    const [pointOfSale, setPointOfSale] = useState(customerOrder.OrderingPoint) //useState(customerOrder.order.PointOfOrdering)
    const [date, setDate] = useState(customerOrder.SalesDate)
    const [paymentMethodForBillDue, setPaymentMethodForBillDue] = useState(customerOrder.PaymentMethodForBillDue)
    const [deliveryAgent, setDeliveryAgent] = useState(customerOrder.DeliveryAgent)
    const [dateRemainingPayment, setDateRemainingPayment] = useState(customerOrder.RemainingPaymentDate)
    const [dateRefundPayment, setDateRefundPayment] = useState(customerOrder.RefundPaymentDate)

    const [billnumber, setBillnumber] = useState(customerOrder.billNumber)


    const [dateOrderedDesigner, setDateOrderedDesigner] = useState(customerOrder.OrderedFromLabel)
    const [dateArrived, setDateArrived] = useState(customerOrder.ReceivedFromLabel)
    const [dateShipped, setDateShipped] = useState(customerOrder.ShippedToCustomer) //useState(customerOrder.article.ShippedToCustomer)
    const [dateShippedToBoutique, setDateShippedToBoutique] = useState(customerOrder.ShippedToBoutique) //useState(customerOrder.article.ShippedToCustomer)
    const [dateReturned, setDateReturned] = useState(customerOrder.ReturnedByCustomer) //useState(customerOrder.article.ReturnedByCustomer)
    const [datePickedUp, setDatePickedUp] = useState(customerOrder.PickedUpByCustomer) //useState(customerOrder.article.PickedUpByCustomer)

    const [priceUnit, setPriceUnit] = useState(parseDoubleToFloat(customerOrder.SalesPrice)) //useState(parseFloat(parseFloat(customerOrder.article.PriceUnit)).toFixed(2).replace('.', ','))
    const [priceTotal, setPriceTotal] = useState(parseDoubleToFloat(customerOrder.SalesPriceInOverall)) //useState(parseFloat(customerOrder.article.Count * parseFloat(customerOrder.article.PriceAtTimeOfSale)).toFixed(2).replace('.', ','))
    const [prepayment, setPrepayment] = useState(parseDoubleToFloat(customerOrder.PrepaymentInOverall)) //useState(parseFloat(customerOrder.article.Count * parseFloat(customerOrder.article.PrepaymentAtTimeOfSale)).toFixed(2).replace('.', ','))
    const [priceChange, setPriceChange] = useState(parseDoubleToFloat(customerOrder.PriceChange)) //useState(parseFloat((-1) * (parseFloat(customerOrder.article.PriceUnit) - parseFloat(customerOrder.article.PriceAtTimeOfSale))).toFixed(2).replace('.', ','))
    const [balanceDue, setBalanceDue] = useState(parseDoubleToFloat(customerOrder.BalanceDue)) //useState(parseFloat((-1) * (parseFloat(customerOrder.article.PriceUnit) - parseFloat(customerOrder.article.PriceAtTimeOfSale))).toFixed(2).replace('.', ','))

    const [paymentMethod, setPaymentMethod] = useState(customerOrder.PaymentMethod)

    const [notizenAnDesignerHeader, setNotizenAnDesignerHeader] = useState("")
    const [notizenAnFAEXHeader, setNotizenAnFAEXHeader] = useState("")


    console.log('DetailedOrder priceAtTimeOfSale', priceChange)

    const handleSubmit = (e) => {
        e.preventDefault()
        console.log("handleSubmit FetchUpdateB2COrderTransactionsDesignerRemark", )
        console.log("handleSubmit DetailedOrder", customerOrder)
        let orderUpdate = {
            NewRemarkText: remarkAnFAEX,
            OldRemarkSysId: customerOrder.RemarkForFAEXSysId,
            B2COrderArticleDataSysId: customerOrder.B2COrderArticleDataSysId
        }
        console.log("handleSubmit FetchUpdateB2COrderTransactionsDesignerRemark", orderUpdate)

        FetchUpdateB2COrderTransactionsDesignerRemark(orderUpdate, openAlert, null)
        handleCloseOrder()
    }

    useEffect(() => {
        setNotizenAnDesignerHeader(window.i18n('remarkPart1') + (designer.length > 0 ? window.i18n('remarkPart2') + designer + " :" : window.i18n('remarkPart3') + " :"))
    }, designer)

    useEffect(() => {
        setNotizenAnFAEXHeader(window.i18n('remarkPart1') + (pointOfSale.length == 0 ? window.i18n('remarkPart2') + " FAEX :" : window.i18n('remarkPart2') + (!pointOfSale.toLowerCase().includes("faex") ? pointOfSale + window.i18n('remarkPart4') : pointOfSale)))
    }, pointOfSale)

    const handleSetOrderState = (e) => {
        e.preventDefault()

        setOrderState(allOrderStates.OrderStates.find(x => enumvaluetranslations(x.OrderState) === e.target.value))
    } 

    const handleSetOrderProcessingState = (e) => {
        e.preventDefault()
    //    setOrderProcessingState(allOrderProcessingStates.OrderProcessingStates.find(x => EnumValueTranslations(x.OrderProcessingState) === e.target.value))
    } 

    return (
        <div lang="de" className="detailedOrder">
            <Form noValidate onSubmit={handleSubmit} id='update-order-form'>
                <Form.Group controlId="article-select">
                    {/*<Form.Label className="controlTitleHeader">Bestelldaten</Form.Label>*/}

                    <Row className="mb-3">
                        <Form.Group as={Col} md={3} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('label')}:</Form.Label>
                            <Form.Control as="input" disabled value={designer}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={3} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('dateOfOrdering')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDate(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDate(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={date} />
                            </DateRangePicker>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">{window.i18n('orderStatus')}:</Form.Label>
                            <Form.Control disabled value={window.i18n(orderState)}>
                            </Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={6} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('prototype')}:</Form.Label>
                            <Form.Control as="input" disabled value={articleType} size={{ width : "13em" }}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">{window.i18n('orderProcessingStatus')}:</Form.Label>
                            <Form.Control disabled value={window.i18n(orderProcessingState)}>
                            </Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('size')}:</Form.Label>
                            <Form.Control as="input" disabled value={size}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('unitPrice')}:</Form.Label>
                            <Form.Control className="numberColumn" type="number" as="input" disabled value={priceUnit}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('priceIncrement')}:</Form.Label>
                            <Form.Control className="numberColumn" type="number" as="input" disabled value={priceChange}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">{window.i18n('customer')}:</Form.Label>
                            <Form.Control as="input" disabled value={customer}></Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('amount')}:</Form.Label>
                            <Form.Control className="numberColumn" type="number" as="input" disabled value={amount}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('sum')}:</Form.Label>
                            <Form.Control className="numberColumn" type="number" as="input" disabled value={priceTotal}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('prepayment')}:</Form.Label>
                            <Form.Control className="numberColumn" type="number" as="input" disabled value={prepayment}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={6} controlId="customGroup01-03">
                            <Form.Label className="controlTitle">{window.i18n('placeOfOrdering')}:</Form.Label>
                            <Form.Control as="input" disabled value={pointOfSale}></Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={3} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">{window.i18n('paymentTypeForPrepayment')}:</Form.Label>
                            <Form.Control as="input" disabled value={enumvaluetranslations(paymentMethod)}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('outstandingBalance')}:</Form.Label>
                            <Form.Control className="numberColumn" type="number" as="input" disabled value={balanceDue}></Form.Control>
                        </Form.Group>

                        <Form.Group as={Col} md={2} controlId="customGroup01-01" >
                            <Form.Label className="controlTitle">{window.i18n('paymentDueTo')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateRemainingPayment(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateRemainingPayment(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={dateRemainingPayment} autocomplete="off" />
                            </DateRangePicker>
                        </Form.Group>
                        <Form.Group as={Col} md={3} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">{window.i18n('paymentMethodForBillDue')}:</Form.Label>
                            <Form.Control as="input" disabled value={enumvaluetranslations(paymentMethodForBillDue)}>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group as={Col} md={2} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">{window.i18n('deliveredViaAgend')}:</Form.Label>
                            <Form.Control as="input" disabled value={enumvaluetranslations(deliveryAgent)}>
                            </Form.Control>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={3} controlId="customGroup01-01" >
                            <Form.Label className="controlTitle">{window.i18n('refundDate')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateRefundPayment(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateRefundPayment(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={dateRefundPayment} autocomplete="off" />
                            </DateRangePicker>
                        </Form.Group>

                        <Form.Group as={Col} md={4} controlId="customGroup01-02">
                            <Form.Label className="controlTitle">{window.i18n('billnumber')}:</Form.Label>
                            <Form.Control disabled type="textarea" label="Rechnungsnummer"
                                value={billnumber}/>
                        </Form.Group>
                    </Row>

                    <Row className="mb-3">
                        <Form.Group as={Col} md={4} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{window.i18n('orderedAtDesigner')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateOrderedDesigner(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateOrderedDesigner(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={dateOrderedDesigner} />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">{window.i18n('deliveredToFAEX')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateArrived(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateArrived(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={dateArrived} />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">{window.i18n('dispatchedToCustomer')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateShipped(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateShipped(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={dateShipped} />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">{window.i18n('dispatchedToBoutique')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                }}
                                onCallback={(manualDate) => setDateShippedToBoutique(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateShippedToBoutique(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={dateShippedToBoutique} autocomplete="off" />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">{window.i18n('retouredByCustomer')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                    drops: "up",
                                }}
                                onCallback={(manualDate) => setDateReturned(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDateReturned(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={dateReturned} />
                            </DateRangePicker>

                            <Form.Label className="controlTitle">{window.i18n('pickedUpByCustomer')}:</Form.Label>
                            <DateRangePicker
                                initialSettings={{
                                    singleDatePicker: true,
                                    showDropdowns: true,
                                    locale: {
                                        cancelLabel: 'Abbrechen',
                                        applyLabel: 'Ok'
                                    },
                                    autoUpdateInput: false,
                                    minYear: 2000,
                                    maxYear: parseInt(moment().format('YYYY'), 10),
                                    parentEl: ".update-order-form",
                                    drops: "up",
                                }}
                                onCallback={(manualDate) => setDatePickedUp(moment(manualDate).format("DD.MM.YYYY"))}
                                onApply={(e, picker) => { picker.element.val(picker.startDate.format('DD.MM.YYYY')); setDatePickedUp(moment(picker.startDate).format("DD.MM.YYYY")) }}>
                                <FormControl as="input" disabled className="form-control" defaultValue={datePickedUp} />
                            </DateRangePicker>
                        </Form.Group>

                        <Form.Group as={Col} md={8} controlId="customGroup01-01">
                            <Form.Label className="controlTitle">{notizenAnDesignerHeader}</Form.Label>
                            <Form.Control className="order-textarea" as="textarea" disabled value={remarkAnDesigner}></Form.Control>
                            <Form.Label className="controlTitle">{notizenAnFAEXHeader}</Form.Label>
                            <Form.Control className="order-textarea" as="textarea" value={remarkAnFAEX} onChange={(e) => setRemarkAnFAEX(e.target.value)}></Form.Control>
                        </Form.Group>
                    </Row>
                </Form.Group>
            </Form>
        </div>
    );
}

export { DetailedOrder }